import { render, staticRenderFns } from "./SubscriptionForm.Purchase.AstropayForm.vue?vue&type=template&id=47e75ebd&scoped=true&"
import script from "./SubscriptionForm.Purchase.AstropayForm.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.Purchase.AstropayForm.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionForm.Purchase.AstropayForm.vue?vue&type=style&index=0&id=47e75ebd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e75ebd",
  null
  
)

export default component.exports